import * as moment from 'moment';


export class Constants {
    static readonly Localization = {
        commonAreas: ['menu', 'status', 'about', 'user_profile']
    }
    //service Urls
    static readonly API_URLS = {
        agents: "product",
        getagents: "sec-api/get-user?countryId=",
        login: "api/login",
        csrf: "api/get-csrf-token",
        recoverypassword: 'api/recoverPassword',
        changePassword: 'sec-api/change-password',
        searchByPhone: 'sec-api/get-building-details-by-phonenumber',
        getGeoCodeByAddress: 'sec-api/get-geoCode-address?address=',
        editUserPreferences: 'sec-api/edit-user-preferences',
        //Manage Users
        editUser: 'sec-api/edit-user',
        deleteUser: 'sec-api/delete-user',
        addUser: 'sec-api/add-user',
    }
    // REM Data Alarms
    static readonly REMDataAlarms_API_URLS=
    {
        getDataAlarmsByCountry: 'sec-api/get-dataalarms-country',
        getADDataAlarmsByCountry: 'sec-api/get-ad-dataalarms-country'
    }

    // Phone Numbers for REM and AD
    static readonly PhoneNumbers_API_URLS=
    {
        //REM Phnoe Numbers
        getAllPhoneNumbers: 'sec-api/get-all-phone-numbers',
        updatePhoneNumber: 'sec-api/update-rem-phone-number',
        deleteElevatorUnit:'sec-api/delete-elevator-unit',

        //autodialer numbers
        getAllAutoDialers:'sec-api/get-all-autoDialers',
        upsertAutoDialer:'sec-api/upsert-autoDialer'
    }
    
    // Failed Calls Reports
    static readonly FailedCalls_API_URLS=
    {
        getFailedCallDetailsByCountry:'sec-api/get-failed-calls'
    }

    static readonly Screen_Pop_API_URLS = {
        insertToDatabase: "api/pop-up/insert-to-database",
        logException: "api/pop-up/log-exception",
        logMessage: "api/pop-up/log-message",
        getTokens: "api/get-tokens-for-screenpop?identity=",
        getQuestionsAndShutdownReasons: "api/pop-up/get-question-n-shutdownreason?countryId=",
        modifyMicGainWin: 'api/pop-up/modify-elevator-micgain',
        modifySpeakerVolumeWin: 'api/pop-up/modify-elevator-speakervolume',
        insertChatMsgDetails: 'api/pop-up/insert-chat-message-details',
        getWinElevatorInfo: 'api/pop-up/get-elevator-info',
        getWinToken: 'api/pop-up/identity-token/',
        completeCall: 'api/pop-up/complete-current-call',
        languageString: '../json/:page',
        roomDetails: 'sec-api/pop-up/get-inprogress-details'
    }

    static readonly elevator_call_URLS = {
        workerToken: 'sec-api/workerToken',
        updateUserActivity: 'sec-api/update-user-activity',
        updateActivity: 'api/update-activity',
        refreshToken: 'sec-api/refresh-token',
        updateCall: 'sec-api/update-call',
        insertChatMsgDetails: 'sec-api/insert-chat-message-details',
        addException: 'api/log-exception',
        addMessage: 'api/log-message',
        getLogFiles: 'api/list-log-files',
        getIdentityToken: 'sec-api/identity-token',
		sendEmailToSupervisor: 'sec-api/send-email-for-supervisor',
        retrieveCallDetailsElevator: 'sec-api/retrieve-call-details-elevator',
        getWorkerCallActivities: 'sec-api/get-workers-call-activity',
        getTPAStatus: 'sec-api/get-tpa-status',
        getAgentStatusFromTwilio: 'sec-api/check-available-workers-from-twilio',
        insertCallDetails: 'sec-api/insert-call-details',
        updateCallDetails: 'sec-api/update-call-details',
        retrieveCallDetailsCountry: 'sec-api/retrieve-call-details-country',
		retrieveCallDetailsIncident: 'sec-api/retrieve-call-details-incident',
        getWorkersForSupervisor:'sec-api/get-workers-report-for-supervisor',
        callTransfer: 'sec-api/call-transfer',
        updateNotes: 'sec-api/update-notes',
        saveElevatorUnitNumberForFactoryNo: 'sec-api/save-display-elevator-number',
        getVoiceIdentityToken: 'sec-api/voice-identity-token',
        
    }
    //Call disposition
    static readonly call_disposition_URLS = {
        saveCallDisposition: 'sec-api/save-call-disposition',
        getAllCallDisposition: 'sec-api/retrieve-call-dispstn-details',
        insertSallDisposition: 'sec-api/insert-calldispstn-details',
        editCallDisposition: 'sec-api/update-call-dispstn-details',
        deleteByCallDispositionId: 'sec-api/delete-call-dispstn-details',
        loadCopyDisposition: 'sec-api/load-copy-disposition',
    }
    //// G3MS APIs & CIMS APIs
    static readonly G3MS_URLS = {
        //getElevatorInfo: 'sec-api/get-elevator-info',
        getElevatorInfo: 'sec-api/get-rem-info',
        stopStartVideo: 'sec-api/start-stop-elevator-video',
        callbackFromElevator: 'sec-api/callback-elevator',
        callbackFromElevatorForAvaya: 'sec-api/callback-elevator-for-avaya',
        modifyMicGain: 'sec-api/modify-elevator-micgain',
        modifySpeakerVolume: 'sec-api/modify-elevator-speakervolume',
        modifyMicGainWin: 'sec-api/win/modify-elevator-micgain',
        modifySpeakerVolumeWin: 'sec-api/win/modify-elevator-speakervolume',
        callBackElevator: 'sec-api/retrieve-elevator-details',
    }
    //service urls for otisline setting
    static readonly otislinesetting_API_URLS = {
        getAllcountryConfig: "sec-api/get-all-country-config",
        addCountryConfig: "sec-api/add-country-config",
        updateCountryConfig: "sec-api/edit-country-config-byId",
        deleteOtislineSetting: 'sec-api/delete-country-config-byId',
        getAvayaUsers: "sec-api/get-avaya-users?countryId=",
        saveAvayaUser: 'sec-api/save-avaya-user',
        deleteAvayaUser: 'sec-api/delete-avaya-user',
        managephonenumbers: 'sec-api/get-all-available-numbers',
        managerightphonenumbers: 'sec-api/get-user-right',
        updateManageRightPhoneNumbers: 'sec-api/grand-revoke-user-right',
        standardQuestions: 'sec-api/retrieve-avaya-chat-message',
        deleteStandardQuestion: 'sec-api/delete-avaya-chat-message?',
        updateStandardQuestion: 'sec-api/insert-avaya-chat-message',
        shutdownReasons: 'sec-api/retrieve-shutdown-reason',
        addEditShutdownReasons: 'sec-api/insert-shutdown-reason',
        deleteShutdownReasons: 'sec-api/delete-shutdown-reason',
        countryshutdownReasons: 'sec-api/retrieve-country-shutdown-reason',
        editCountryShutdownReason: 'sec-api/save-call-disposition-data',
        deleteCountryShutdownReason: 'sec-api/delete-country-shutdown-reason',
        deleteCountryShutdownReason1: 'sec-api/delete-call-disposition',
        requestPhoneNumber: 'sec-api/request-phone-number',
        releasePhoneNumber: 'sec-api/release-phone-number?phoneNumber=',

        //Call disposition
		saveCallDisposition: '/sec-api/save-call-disposition',
		getAllCallDisposition: '/sec-api/retrieve-call-dispstn-details',
		insertSallDisposition: 'sec-api/insert-calldispstn-details',
		editCallDisposition: '/sec-api/update-call-dispstn-details',
		deleteByCallDispositionId:  'sec-api/delete-call-dispstn-details',
		loadCopyDisposition: '/sec-api/load-copy-disposition',
        getr2cCallDisposition: 'sec-api/retrieve-call-dispstn-details',

        //Country Call disposition
        getcountryCallDispositions: 'sec-api/retrieve-call-disposition',

        //upload
        getDataImportDetails: 'sec-api/get-dataimport-country?',
        getBlobUrl: 'sec-api/get-sas-url',
        uploadfile:'api/upload',

        //Language Skill
		getLanguageSkills: 'sec-api/get-language-skills',
		saveLanguageSkill: 'sec-api/save-language-skill',
		deleteLanguageSkill: 'sec-api/delete-language-skill',
    }

    static readonly AGENT_DASHBOARD_URLS = {
        getAvayaCalls: 'sec-api/get-avaya-calls',
        updateLanguage: 'sec-api/update-language',
        getCallDetail: 'sec-api/get-call-detail',
        getCallReport: 'sec-api/get-worker-report',
        clearTpr: 'sec-api/clear-tpr',
    }

    //service urls for Reports
    static readonly Reports_API_URLS = {
        getAgentReport: 'sec-api/get-agents-report'
    }

    //Supervisor Dashboard URL
    static readonly SUPERVISOR_DASHBOARD_URLS = {
        getWorkersForSupervisor:'sec-api/get-workers-report-for-supervisor',
        getSupervisorTeams: 'sec-api/get-supervisor-teams',
        getSupervisorDashboardReportDetails: 'sec-api/get-workers-report-details-for-supervisor',
        getWorkersStatistics: 'sec-api/get-workers-report'
    }

    //service urls for otisline setting
    static readonly logs_API_URLS = {
        retriveExceptionDetails: 'sec-api/retrieve-exception-detail',
    }
    //service urls for Search Tab
    static readonly search_API_URLS = {
        getAvayaCalls: "sec-api/get-avaya-calls",
        getAvayaCallsById: "sec-api/get-avaya-call?callId=",
        //getCallSummary:"sec-api/get-call-summary"
        getCallSummary:"sec-api/retrieve-call-details-country"
    }

    //g3ms constants
    static readonly G3MS_COMMANDS = {
        'startVideo': 'resumeRemoteVideo',
        'stopVideo': 'stopRemoteVideo',
        'joinRoom': 'joinRoom',
        'msg': 'displayTextMessage',
        'micGain': 'adjustMicrophoneGain',
        'speakerVolume': 'adjustVolume',
        'joinRoomNew': 'joinVideoRoom',
    }

    // Filter values of call failure type
    static readonly CALL_FAILURE_FILTER = [
		{ id: 0, text: 'All', type: 'All' },
		{ id: 1, text: 'Calls Failed Before Answer', type: 'Answered' },
		{ id: 2, text: 'Calls Failed After Answer', type: 'MyCall' }        
    ];

    // Filter values of models
	static readonly MODEL_FILTER= [
		{ id: 1, text: 'SafeLine', type: 'SafeLine', isShared: false },
        { id: 2, text: 'Memcom', type: 'Memcom', isShared: true }];
    
    static readonly PROTOCOL_FILTER= [
		{ id: 1, text: 'P100', type: 'P100', isShared: false },
        { id: 2, text: 'Voice', type: 'Voice', isShared: true }];

    // Filter values of models
	static readonly UNIT_NUMBER= [
		{ id: 0, value: 0},
		{ id: 1, value: 1},
        { id: 2, value: 2},
        { id: 3, value: 3},
        { id: 4, value: 4},
        { id: 5, value: 5},
        { id: 6, value: 6},
        { id: 7, value: 7},
        { id: 8, value: 8}];

    
    //user working hours
    static readonly USER_WORKING_HOURS = [
        { id: 1, text: 'employee', type: 'Employee' },
        { id: 2, text: 'contractor', type: 'Contractor' }
    ];
    //user profile types
    static readonly USER_PROFILE_TYPES = [
        { id: 0, text: 'select', type: 'Select' },
        { id: 1, text: 'Active', type: 'Active' },
        { id: 2, text: 'Retired', type: 'Retired' }
    ];
    // CCC user/agent status
    static readonly USER_FILTER_TYPES = [
        { id: 0, text: 'All', type: 'All' },
        { id: 1, text: 'Active', type: 'Active' },
        { id: 2, text: 'Retired', type: 'Retired' }
    ];

     // Filter values for repeated TPA calls tab in ccc agent dashboard page3`el
     static readonly REPEATED_TPA_FILTER = [
        { id: 0, text: 'activeCalls', type: 'Active Calls' },
        { id: 1, text: 'closedCalls', type: 'Closed Calls' }
    ];
    //user roles
    static readonly USER_ROLES = [
        //{ id: 0, priority: 0, isDisplay: 1, isAgent: 1, text: 'select', role: 'Select' },
        // { id: 3, priority: 5, isDisplay: 1, isAgent: 0, text: 'Admin', role: 'Admin' },
        // { id: 2, priority: 4, isDisplay: 1, isAgent: 1, text: 'otisLineAdministrator', role: 'OTISLine Administrator' },
        // { id: 1, priority: 1, isDisplay: 1, isAgent: 1, text: 'Agent', role: 'OTISLine Agent' },
        // { id: 7, priority: 2, isDisplay: 1, isAgent: 0, text: 'otisLineRemortExpert', role: 'OTISLine Remote Expert' },
        // { id: 8, priority: 3, isDisplay: 1, isAgent: 1, text: 'Supervisor', role: 'OTISLine Supervisor' }
        { id: 0, text: 'select', role: 'Select' },
		{ id: 2, text: 'Supervisor', role: 'OTISLine Supervisor' },
		{ id: 1, text: 'Agent', role: 'OTISLine Agent' }
    ];
    //user call types
    static readonly USER_CALLTYPES = [
        { id: 1, isDisplay: 1, group: '1', isDisabled: false, isSelected: false, type: 'Commissioning' },
        { id: 2, isDisplay: 1, group: '1', isDisabled: false, isSelected: false, type: 'Production' },
        { id: 3, isDisplay: 1, group: '2', isDisabled: false, isSelected: false, type: 'FactoryTest' },
        { id: 4, isDisplay: 0, group: '3', isDisabled: false, isSelected: false, type: 'Operations' }
    ];

    // Available Twilio media region
    static readonly MEDIA_REGION = [
        { id: "1", code: "sydney", value: 'Australia' },
        { id: "2", code: "sao-paulo", value: 'Brazil' },
        { id: "3", code: "frankfurt", value: 'Germany' },
        { id: "4", code: "dublin", value: 'Ireland' },
        //{ id: "5", code: "india", value: 'India' },
        { id: "6", code: "tokyo", value: 'Japan' },
        { id: "7", code: "singapore", value: 'Singapore' },
        { id: "8", code: "ashburn", value: 'US East Coast (Virginia)' },
        //{ id: "9", code: "us2", value: 'US West Coast (Oregon)' },
        { id: "9", code: "roaming", value: 'Others' }  
    ];

    // Available Twilio LANGUAGE CODE
    static readonly LANGUAGE_CODE = [
        { id: 1, code: "da-DK", value: "Danish, Denmark" },
		{ id: 2, code: "de-DE", value: "German, Germany" },
		{ id: 3, code: "en-AU", value: "English, Australia" },
		{ id: 4, code: "en-CA", value: "English, Canada" },
		{ id: 5, code: "en-GB", value: "English, UK" },
		{ id: 6, code: "en-IN", value: "English, India" },
		{ id: 7, code: "en-US", value: "English, United States" },
		{ id: 8, code: "ca-ES", value: "Catalan, Spain" },
		{ id: 9, code: "es-ES", value: "Spanish, Spain" },
		{ id: 10, code: "es-MX", value: "Spanish, Mexico" },
		{ id: 11, code: "fi-FI", value: "Finnish, Finland" },
		{ id: 12, code: "fr-CA", value: "French, Canada" },
		{ id: 13, code: "fr-FR", value: "French, France" },
		{ id: 14, code: "it-IT", value: "Italian, Italy" },
		{ id: 15, code: "ja-JP", value: "Japanese, Japan" },
		{ id: 16, code: "ko-KR", value: "Korean, Korea" },
		{ id: 17, code: "nb-NO", value: "Norwegian, Norway" },
		{ id: 18, code: "nl-NL", value: "Dutch, Netherlands" },
		{ id: 19, code: "pl-PL", value: "Polish-Poland" },
		{ id: 20, code: "pt-BR", value: "Portuguese, Brazil" },
		{ id: 21, code: "pt-PT", value: "Portuguese, Portugal" },
		{ id: 22, code: "ru-RU", value: "Russian, Russia" },
		{ id: 23, code: "sv-SE", value: "Swedish, Sweden" },
		{ id: 24, code: "zh-CN", value: "Chinese (Mandarin)"},
		{ id: 25, code: "hu-HU", value: "Hungarian, Hungary" },
    ];

    // Activity status of User
    static readonly ACTIVITY_STATUS = [
        { id: "1", status: 'Available' },
        { id: "2", status: 'Offline' },
        { id: "3", status: 'Not Available' },
        { id: "4", status: 'Not Available: Timeout' },
        { id: "5", status: 'Reserved' },
        { id: "6", status: 'Busy' },
        { id: "7", status: 'Available'}
    ];

     // Activity status of User
     static readonly AGENT_STATUS = [
        { id: "0", text: 'filter0', type: 'All'},
        { id: "1", text: 'filter1',type: 'Available' },        
        { id: "3", text: 'filter3',type: 'Not Available' },   
        { id: "2", text: 'filter2',type: 'Offline' },            
        { id: "12", text: 'filter12',type: 'Online' }       
    ];
    // { id: "11", text: 'filter11',type: 'My Team' },

    // User Twilio status
    static USER_CURRENT_STATUS :  Array<any>= [
        { id: 1, activityId: 1, sId: '', status: 'Idle', text: 'idle'},
        { id: 2, activityId: 0, sId: '', status: 'Reserved', text: 'reserved'},
        { id: 3, activityId: 0, sId: '', status: 'Busy', text: 'busy'},
        { id: 4, activityId: 3, sId: '', status: 'Offline', text: 'offline'},
        { id: 5, activityId: 7, sId: '', status: 'Available', text: 'available'}

    ];
    // User roles for OTISLine pbx
    static readonly AVAYA_USER_ROLES = [
        //{ id: 0, text: 'select', role: 'Select' },
        { id: 4, text: 'avayaUser', type: 'User' },
        { id: 5, text: 'avayaSupervisor', type: 'Supervisor' },
        { id: 6, text: 'avayaRemoteOtisExpert', type: 'Remote Otis Expert' }];

    // Filter values of call summary/ dashboard, isShared used for Avaya, only this filter will be added over there
    static readonly CALL_SUMMARY_FILTER = [
        { id: 0, text: 'all', type: 'All',},
        { id: 1, text: 'answered', type: 'Answered'},
        { id: 2, text: 'myCall', type: 'My Call'},
        { id: 3, text: 'missedCalls', type: 'Missed Calls'},
        { id: 4, text: 'myMissedCalls', type: 'My Missed Calls'},
        { id: 5, text: 'outgoingCalls', type: 'Outgoing Calls'},
        { id: 6, text: 'failedCalls', type: 'Failed Calls' }       
    ];

    // time formate for OTISLine pbx
    static readonly TIME_FORMATES = [
        //{ id: 0, text: 'select', role: 'Select' },
        { code: 'HH:mm', type: '24:00' },
        { code: 'HH:mm:ss', type: '24:00:00' },
        { code: 'hh:mm A', type: '12:00 AM/PM' },
        { code: 'hh:mm:ss A', type: '12:00:00 AM/PM' }];
    static readonly REPORTTIME = {
        'StartTime': '00:00:00',
        'EndTime': '23:59:59'
    }
    static readonly questionYesNoOptions: any = [
        { id: "0", value: 'Select' },
        { id: "1", value: 'Hello, this is the Customer Care Center. I will communicate with you through text. Press the phone button 1 time to answer YES or 2 times to answer NO.' },
        { id: "2", value: 'Can you confirm that you received this question? YES/NO' },
        { id: "3", value: 'Do you need me to switch to English language text messages? YES/NO' },
        { id: "4", value: 'Do you need me to switch to French language text messages? YES/NO' },
        { id: "5", value: 'Do you need me to switch to Spanish language text messages? YES/NO' },
        { id: "6", value: 'Are you stuck in the elevator? YES/NO' },
        { id: "7", value: 'Please press and hold the DOOR OPEN button. Did the elevator doors open? YES/NO' },
        { id: "8", value: 'Thank you. Please exit safely when you are able.' },
        { id: "9", value: 'Check the emergency stop switch to ensure it is in the "RUN" position, or pulled out if it is a red button.  Is it in the "RUN" position? YES/NO' },
        { id: "10", value: 'If the emergency stop switch is a keyswitch--is it pointing to the RUN position? YES/NO' },
        { id: "11", value: "Check the car doors to make sure they are closed all the way. Put your hands on the doors' surface and manually try to push the doors CLOSED. Do NOT put your hands/fingers/any part of your body between the doors. Do NOT try to force the doors open or climb out.   Did the doors open? YES/NO" },
        { id: "12", value: 'Are you able to exit safely now? YES/NO' },
        { id: "13", value: "I'm going to put you on hold to call the building. If we get disconnected, you can press the phone button again.  Do you understand? YES/NO" },
        { id: "14", value: "Please stay in the elevator until a trained professional arrives. Do NOT try to self-evacuate.  Do you understand? YES/NO" },
        { id: "15", value: "Thank you. Please exit safely when you are able.  Do you understand? YES/NO" },
        { id: "16", value: "We have contacted the elevator technician.  Do you understand? YES/NO" },
        { id: "17", value: "We will continue to update you via text message.  Do you understand? YES/NO" },
        { id: "18", value: "Please push the phone button again if you need to communicate before our next update.  Do you understand? YES/NO" },
        { id: "19", value: "The building is aware that you are in the elevator and they are sending someone to help you.  Do you understand? YES/NO" },
        { id: "20", value: "The building is aware that you are in the elevator. We are going to dispatch a mechanic to release you as quickly as possible.  Do you unserstand? YES/NO" }
    ];
    //Report starting to Endtime which will be added to get whole day report
    static readonly REPORTTIMEDATE = {
        'StartTime': '00:00:00',
        'EndTime': '23:59:59',
        "YYYYMMDD": "YYYY-MM-DD",
    };
    static readonly PREVIOUSEDAYS = {
        'number': 6
    };
    static readonly PREVIOUSEMONTHDAYS = {
        'number': 29
    };
    static APP_CONFIG = {
        frameRate: 10,
        showLoaderTimings: 30000,
        workflowTimeout: 60,
        callInitiator: 'Elevator',
        selfInitiator: 'Agent',
        minFrameRate: 7,
        busySid: "",
        deleteSid: "",
        offlineSid: "",
        reservSid: "",
        appVersion: "1.0.1",
        copyright: '2024 Otis Elevator Company.',
        version: 'Version',
        mapZoomLevel: 16,
        testCallCodes: '1001,1002,1003',
        setInterval: 180000, // 300000 ~= 5 minutes,
        isOnlyAudio: true,
        taskQueueKey: "OtisLineTaskQueue-",
        notAvailable: "Offline",
        serverBeatKey: "clientAvailable",
        defaultLanguageShortName: "eng",
        videoinput: "videoinput",
        audioinput: "audioinput",
        deviceCheckTimeout: 15000,
        agentDisconnectTimeout: 5000,
        isTransfer: "true",
        activity9: 9,
        status: "status",
        callTransferTrackRetryCount: 25,
        videoCodec: "H264",
	    audioCodec: 'pcmu',
        maxFileSize:200000000,
        switchOffLogs:false
    }
    static readonly APPCOOKIES = {
        FILTER_PREFERENCE: 'CCC_filter_preference',
        VIDEO_CONTROL_PREFERENCE: 'CCC_video_control_preference',
        AVAYA_USERID: 'CCApp-avaya-userID',
        AVAYA_EMAILID: 'CCApp-avaya-emailId',
        AVAYA_USERNAME: 'CCApp-avaya-userName',
        AVAYA_COUNTRYID: 'CCApp-avaya-languageId',
        AVAYA_LANGUAGEID: 'CCApp-avaya-countryId',
        AVAYA_SCREENPOP_PAGE: 'CCApp-avaya-screenpop_page',
        AVAYA_LANGUAGESTRING: 'CCApp-avaya-screenpop_page',
        CCC_ALARMID: "CCApp-alarmID",
        XSRF: "XSRF-TOKEN",
        CSRF: "_csrf",
        CCC_USERID: "CCApp-userID",
        CCC_ONGOINGCALL: 'CCApp-isOngoingCall',
        CCC_LOGGEDTYPE: 'CCApp-loggedType',
        AVAYA_COUNTRY_SHORTNAME: "CCApp-avaya-countryShortName",
        CCC_TOKEN: "CCApp-token",
        CCC_COUNTRYID: "CCApp-countryId",
        CCC_EMAILID: "CCApp-emailid",
        CCC_SID: "CCApp-sId",
        CCC_ROLEID: "CCApp-roleId",
        CCC_ELEVATORID: "CCApp-elevatorID",
        CCC_INCIDENTID: "CCApp-incidentID",
        CCC_USER_IDENTITY: 'CCApp-userIdentity',
        remgroupId:"0",
        refreshCookie:"undefined",
        Callcount:"CCApp-filteredItems",
    }
    static readonly APPCONSTANTS = {
        timedTerminationSecs: 20,
        timedIntervalSecs: 1000,
        elevatorLabel: "Elevator-",
        hideActivityTimeout: 5000,
        lastElevatorId: "lastElevatorId",
        elevator: "elevator",        
        badRequest: "Bad Request",
        modifySpeakerVolume: "modifySpeakerVolume",
        modifyMicGain: "modifyMicGain",
        scrollHeight: 5000,
        uuidString: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",
        video: "video",
        debug: "debug",
        data: "data",
        unitInformation: "UNIT_INFORMATION",
        TIMED_CALL_TERMINATION: "TIMED_CALL_TERMINATION",
        agent: "Agent",
        true: true,
        AP: 'AP',
        EP: 'EP',
        retryCount: 10,
        style: 'style',
        hidStyle: "opacity:0;transition:opacity 1s linear;*",
        hideStyleTiming: 10000,
        select: "Select",
        defaultLanguage: 'eng',
        defaultCountry: 'US',
        uuidFunction: {
            "function": (c: any) => {
                var r = Math.random() * 16 | 0;
                var v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            },
            "xguid": "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",
            "replaceRegEx": /[xy]/g
        },
        "outOfService": "82"
    };
    static readonly MESSAGES = {
        "reqForIncreasingSpeakerVolume": "Requested to increase speaker volume",
        "reqForMicGain": "Requested to increase mic gain",
        "gettingTwilioRoomDetails": "Getting Twilio Room details.",
        "gettingTwilioRoomDetailsErr": "Getting Room details Error",
        "unableToConnect": "Unable to connect to Room: ",
        "videoTokenRequested": "Twilio video token requested for ",
        "gotToken": "Got Twilio video token for ",
        "getVideoTokenError": "Getting video token got error for ",
        "alreadyInRoom": "Already in Room: '",
        "joining": "Joining",
        "connectivityLost": "You lost connectivity to the Room; attempting to reconnect",
        "reconnectSuccess": "You successfully reconnected to the Room",
        "unitInfoRequested": "UNIT_INFORMATION requested.",
        "getTaskrouterDataFailed": "Getting taskrouter data failed.",
        "waitingForUnitInfo": "Getting UNIT_INFORMATION. Retried",
        "gotTaskrouterData": "Got taskrouter data",
        "gotElevatorInfo": "Got elevator information requested for ",
        "removedTrack": " removed track: ",
        "addedTrack": " added track: ",
        "leftTheRoom": "left the room",
        "gettingElevatorInfo": "Getting elevator information requested for ",
        "disconnectedFromRoom": "Disconnected from room",
        "errOnSavingStandardQuestion": "Error while saving standard questions & responses"
    };
    // static readonly TWILIOEVENTS = {
    //     participantConnected: "participantConnected",
    //     reconnecting: "reconnecting",
    //     reconnected: "reconnected",
    //     trackSubscribed: "trackSubscribed",
    //     message: "message",
    //     trackUnsubscribed: "trackUnsubscribed",
    //     participantDisconnected: "participantDisconnected",
    //     disconnected: "disconnected"
    // };
    static readonly USERTYPE = {
        1: "ccc",
        2: "avaya",
    }

    //Constants & Function constants for OTISLine calls
    static readonly PAGE_CONSTANTS = {
        eventName: "topBarTitle",
        statusMessgaeContainer: "status-msg-fade",
        callbackResponse: { "joinedRoom": 1, "alreadyInRoom": 2, "invalidCountryCode": 4 },
        avayaCalls: {
            "name": "name",
            "url": "/avaya-calls",
            "previous7Days": 7,
            "deleteConfirmModalId": "#delete-confirmation",
            "agentConfigModalId": "#agent-configuration",
            "langFileName": "_avaya_calls.json",
            "callbackModal": "call-back",
            "callDetailsModal": "call-details",
            "sortCalls": "sortCalls",
            "getAvayaCalls": "getAvayaCalls",
            "callbackElevator": "callBackElevatorForAvaya",
            "g3msStatus": { "C400": 400, "C401": 401, "C503": 503, "C500": 500, "C1000": 1000 },
            "callbackModalName": "call-back",
            "elevatorCallback": "elevatorCallbackForAvaya",
            "messages": { "callbackG3MSFailed": "callbackG3MSFailed" },
            "getLanguageString": "getLanguageString",
            "clActivity": "cl-activity",
            "uuidFunction": {
                "function": (c: any) => {
                    var r = Math.random() * 16 | 0;
                    var v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                },
                "xguid": "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",
                "replaceRegEx": /[xy]/g
            },
            "resetCurrentPage": "search.searchTextCalls"
        },
        //Constants & function for AppComponent
        home: {
            visualAlertTitle: "CLOUD OTISLine",
            visualAlertIcon: "/images/incoming-call.gif",
            getVisualAlertTimeout: (time: any) => {
                if (time) {
                    return parseInt(time) * 1000
                }
                else {
                    return 25000;
                }
            },
            logoutConfirm: "Logout.confirm",
            logoutConfirmMsg: "No available agent",
            noAvailableAgent: 2000,
            logoutYesMsg: "Agent decieded to logout after confirmation",
            status: {
                "availableIndex": 1,
                "logoutIndex": 3
            },
            logout: "logout",
            changeStatus: "status",
            logoutYes: "logout-confirm",
            activityId: 2
        },
    }
    //Application constants are specified and used in application
    static readonly APP_CONSTANTS = {
        'emailRegEx': /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'duplicateCode': '2001',
        'incoming': 'incoming',
        'avayaShutdownReason': 'avaya-shutdown-reason',
        'avayaShutdownReasonForTrans': 'avaya-shutdown-reason-trans',
        'avayaTeams': 'avaya-supervisor-teams',
        'all': 'all',
        "hidebars": "hidebars",
        "true": true,
        "false": false,
        "statusMsgFade": "status-msg-fade",
        "zero": 0,
        "one": 1,
        "dash": "_",
        "afterRefresh": "afterRefresh",
        "select": "select",
        "callEvents": "callEvents",
        "changeLanguage": "changeLanguage",
        "changeCountry": "changeCountry",
        "none": "none",
        "block": "block",
        "numberOfPages": 0,
        "currentPage": 0,
        "pageSize": 10,
        "minusOne": -1,
        "YYYYMMDD": "YYYY-MM-DD",
        "badRequest": "Bad Request",
        "usShortName": "US",
        "outOfService": "82"
    };
    static GetCookieExpredDate(year: number) {
        var now = new Date();
        return new Date(now.getFullYear() + year, now.getMonth(), now.getDate());
    }
    static readonly ROOM_AUDIO_VIDEO_CONSTANTS = {
        "audio": {
          "autoGainControl": false,
          "channelCount": 1,
          "echoCancellation": true,
          "latency": 0,
          "noiseSuppression": false,
          "sampleRate": 8000,
          "sampleSize": 16,
          "volume": 1.0
        },
        "video": {
          "width": 320,
          "height": 240,
          "frameRate": 10
        },
        "preferredAudioCodecs": [
          "pcmu"
        ],
        "preferredVideoCodecs": [
          "H264"
        ]
      }
}
